import { render, staticRenderFns } from "./activitiesDetail2021jy.vue?vue&type=template&id=5ffa8ff0&scoped=true"
import script from "./activitiesDetail2021jy.vue?vue&type=script&lang=js"
export * from "./activitiesDetail2021jy.vue?vue&type=script&lang=js"
import style0 from "./activitiesDetail2021jy.vue?vue&type=style&index=0&id=5ffa8ff0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ffa8ff0",
  null
  
)

export default component.exports